import {ApiConfig} from '@employee-configs/api.config';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BulkProvisionApiService {
    constructor(private httpClient: HttpClient) {
    }

    getBulkProvisionGrid(
        request: EmployeeModels.DM.IMobileDeviceGridRequest
    ): Observable<EmployeeModels.DM.IMobileDeviceGridResponse | { error: HttpErrorResponse }> {
        return this.httpClient
            .post<EmployeeModels.DM.IMobileDeviceGridResponse | { error: HttpErrorResponse }>(
                ApiConfig.BulkProvision.getBulkProvisionGrid,
                request
            )
            .pipe(
                map((data: EmployeeModels.DM.IMobileDeviceGridResponse) => {
                    return data;
                }),
                catchError(error => of({error})),
            );
    }

    bulkPushAction(
        request: EmployeeModels.DM.IEmployeeMobileDeviceBulkActionRequest
    ): Observable<EmployeeModels.DM.IMobileBadgeRequestBulkActionResponse | { error: HttpErrorResponse }> {
        return this.httpClient
            .post<EmployeeModels.DM.IMobileBadgeRequestBulkActionResponse | { error: HttpErrorResponse }>(
                ApiConfig.BulkProvision.bulkPushAction,
                request
            )
            .pipe(
                catchError(error => of({error})),
            );
    }

    bulkPushActionAll(
        request: EmployeeModels.DM.IEmployeeMobileDeviceBulkAllActionRequest
    ): Observable<EmployeeModels.DM.IMobileBadgeRequestBulkActionResponse | { error: HttpErrorResponse }> {
        return this.httpClient
            .post<EmployeeModels.DM.IMobileBadgeRequestBulkActionResponse | { error: HttpErrorResponse }>(
                ApiConfig.BulkProvision.bulkPushActionAll,
                request
            )
            .pipe(
                catchError(error => of({error})),
            );
    }

    pushAction(
        request: EmployeeModels.DM.IEmployeeMobileDeviceActionRequest
    ): Observable<null | { error: HttpErrorResponse }> {
        return this.httpClient
            .post<null | { error: HttpErrorResponse }>(
                ApiConfig.BulkProvision.pushAction,
                request
            )
            .pipe(
                catchError(error => of({error})),
            );
    }

}
